import { render, staticRenderFns } from "./TextEditorControl.vue?vue&type=template&id=6d1f4b6c&scoped=true"
import script from "./TextEditorControl.vue?vue&type=script&lang=js"
export * from "./TextEditorControl.vue?vue&type=script&lang=js"
import style0 from "./TextEditorControl.vue?vue&type=style&index=0&id=6d1f4b6c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f4b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1f4b6c')) {
      api.createRecord('6d1f4b6c', component.options)
    } else {
      api.reload('6d1f4b6c', component.options)
    }
    module.hot.accept("./TextEditorControl.vue?vue&type=template&id=6d1f4b6c&scoped=true", function () {
      api.rerender('6d1f4b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/TextEditorControl.vue"
export default component.exports